import { useRef, useState } from "react";
import { useCloseOnNavigate } from "./useCloseOnNavigate";

const useInitiativeSelection = (mutations) => {
  const {
    onEditInitiative,
    onInitiativeArchive,
    onInitiativeUnarchive,
    onInitiativeDelete,
    onInitiativeAddComment,
    onInitiativeEditComment,
    onInitiativeDeleteComment,
    currentUserId,
    isAdmin,
  } = mutations;

  const [selected, setSelected] = useState(null);
  const selectedRef = useRef(selected);
  selectedRef.current = selected;

  const select = (initiative) => setSelected(initiative);
  const close = () => setSelected(null);

  useCloseOnNavigate(close);

  const editSelected = onEditInitiative
    ? () => {
        onEditInitiative(selected);
        close();
      }
    : undefined;

  const archiveToggleSelected = onInitiativeArchive
    ? async () => {
        if (!selected) return;
        const id = selected.id;
        const fn = selected.archived
          ? onInitiativeUnarchive
          : onInitiativeArchive;
        const data = await fn(id);
        if (selectedRef.current?.id !== id) return;
        if (data) select(data);
        else close();
      }
    : undefined;

  const deleteSelected = onInitiativeDelete
    ? () => {
        if (!selected) return;
        onInitiativeDelete(selected.id);
        close();
      }
    : undefined;

  const addCommentSelected = onInitiativeAddComment
    ? async (text) => {
        if (!selected) return null;
        const id = selected.id;
        const data = await onInitiativeAddComment(id, text);
        if (selectedRef.current?.id !== id) return data;
        if (data) select(data);
        else close();
        return data;
      }
    : undefined;

  const editCommentSelected = onInitiativeEditComment
    ? async (commentId, text) => {
        if (!selected) return null;
        const id = selected.id;
        const data = await onInitiativeEditComment(id, commentId, text);
        if (selectedRef.current?.id !== id) return data;
        if (data) select(data);
        else close();
        return data;
      }
    : undefined;

  const deleteCommentSelected = onInitiativeDeleteComment
    ? async (commentId) => {
        if (!selected) return null;
        const id = selected.id;
        const data = await onInitiativeDeleteComment(id, commentId);
        if (selectedRef.current?.id !== id) return data;
        if (data) select(data);
        else close();
        return data;
      }
    : undefined;

  return {
    selected,
    select,
    close,
    editSelected,
    archiveToggleSelected,
    deleteSelected,
    addCommentSelected,
    editCommentSelected,
    deleteCommentSelected,
    currentUserId,
    isAdmin,
  };
};

export default useInitiativeSelection;
